import { apiClient } from '@app/lib'
import { useSugarContext } from '@app/providers'
import { type SugarPublishedTuitionRatesHistoryResponse } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import ms from 'ms'
import { useSession } from 'next-auth/react'

export const useTuitionRatesHistory = () => {
  const session = useSession()
  const { siteId } = useSugarContext()

  return useQuery({
    enabled: session.status === 'authenticated' && Boolean(siteId),
    queryKey: ['tuitionRatesHistory', siteId],
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<SugarPublishedTuitionRatesHistoryResponse>(
        '/api/published-tuition-rates/history',
        {
          params: { siteId },
          signal
        }
      )

      return data.data
    },
    staleTime: ms('1h')
  })
}
